import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { TradeMarkAPI } from "../../../../services/trademark";
import { setModalOpen } from "../../../../store/modal/slice";
import MainSelect from "../../../../components/main-select/main-select";
import Button from "../../../../components/button/button";
import {
  DOWNLOAD_SELECT_OPTIONS,
  PRINT_TYPES,
} from "../../../../constant/trademark";
import { setLoading } from "../../../../store/loading/slice";

import styles from "../../styles.module.scss";

const DownloadFile = ({ modalId, offset, searchValue }) => {
  const dispatch = useDispatch();

  const { filter } = useSelector((state) => state.tradeMark);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      pdf_image: "",
      page_pdf_info: "",
      print: "",
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    dispatch(setLoading(true));
    
    try {
      if (data.page_pdf_info === "a_page") {
        data.offset = offset * 20;
        data.limit = 20;
      }
      if (searchValue) data.trade_mark_name = searchValue;
      if (filter) {
        const paramsWithFilter = {
          ...filter,
          ...data,
        };
        await dispatch(
          TradeMarkAPI.getTradeMarks({
            ...paramsWithFilter,
          }),
        ).unwrap();
      } else {
        await dispatch(
          TradeMarkAPI.getTradeMarks({ ...data, trade_mark_name: searchValue }),
        ).unwrap();
      }

      dispatch(setModalOpen({ modalId, isOpen: false }));
    } finally {
      dispatch(setLoading(false));
    }
  });

  return (
    <div>
      <h2>Արտածել</h2>
      <MainSelect
        name="print"
        control={control}
        className={styles.pdf_select}
        placeholder="Արտածման ձևաչափ"
        options={PRINT_TYPES}
      />
      <MainSelect
        name="pdf_image"
        control={control}
        className={styles.pdf_select}
        placeholder="Նկարի առկայություն"
        options={DOWNLOAD_SELECT_OPTIONS}
      />
      <MainSelect
        control={control}
        name="page_pdf_info"
        className={styles.pdf_select}
        placeholder="Ապրանքային նշանների ցանկը"
        options={[
          { value: "a_page", label: "Ընթացիկ էջը" },
          { value: "full_page", label: "Ամբողջ ցանկը" },
        ]}
      />
      <Button className={styles.pdf_btn} variant="outlined" onClick={onSubmit}>
        Հաստատել
      </Button>
    </div>
  );
};

export default DownloadFile;
